<template>
    <div class="container">
        <div class="hill-section" id="office">
            <h3 class="title">Office Space</h3>
            <p class="intro">Our commercial office buildings allow for businesses of all types to grow and thrive. Located in dynamic communities, our office spaces feature amenities such as parking, 24-hour security, Wi-Fi and more.
</p>
            <div class="columns is-multiline is-hidden-mobile">
                <div class="column is-6" v-for="img in bigimage" :key="img.id">
                    <div class="image-gal">
                        <img v-lazy="img.img" alt="">
                    </div>
                </div>
                <div class="column is-3" v-for="img in smallimage" :key="img.id">
                    <div class="image-gal">
                        <img v-lazy="img.img" alt="">
                    </div>
                </div>
            </div>

            <div class="is-hidden-desktop">
                <div class="columns office-for">
                    <div class="column" v-for="img in allImages" :key="img.id">
                        <div class="image-gal">
                            <img v-lazy="img.img" alt="">
                        </div>
                    </div>
                </div>
                <div class="columns office-nav">
                    <div class="column" v-for="img in allImages" :key="img.id">
                        <div class="image-gal">
                            <img v-lazy="img.img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                bigimage:[
                    {img: '/image/office3.jpg'},
                    {img: '/image/office4.jpg'},
                ],
                smallimage:[
                    {img: '/image/office1.jpg'},
                    {img: '/image/office6.jpg'},
                    {img: '/image/office5.jpg'},
                    {img: '/image/office7.jpg'},
                ],
                allImages:[
                    {img: '/image/office3.jpg'},
                    {img: '/image/office4.jpg'},
                    {img: '/image/office1.jpg'},
                    {img: '/image/office6.jpg'},
                    {img: '/image/office5.jpg'},
                    {img: '/image/office7.jpg'},
                ]
            }
        },
        methods: {
            OfficeMobileSlider(){
                $('.office-for').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: '.slider-nav'
                });
                $('.office-nav').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: '.slider-for',
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true,
                    arrows: false
                });
            } 
        },
        mounted(){
            this.OfficeMobileSlider();
        }
    }
</script>

<style lang="scss" scoped>
.columns{
    margin: 0;
    padding: 0;
    .column{
        margin: 0;
        padding: 5px;
        &:first-child{
            margin: 0;
            padding-bottom: 5px;
        }
        .slick-slide.slick-current.slick-active.slick-center{
            border: 1px solid $color-sub;
        }
        .image-gal{
            position: relative;
            overflow: hidden;
            &::before{
                display: block;
                content: "";
                width: 100%;
                padding-top: 70%;
            }
            img{
                height: 100%;
                -o-object-fit: cover;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
            }
        }
    }
}
</style>